import data from "./Stores.json";
import { Store } from "../Platform/Store";
import { Server } from "../Platform/Server";
import * as AV from "../AVCore/Interfaces/AV.Interfaces";

export class MediaStore {
  private static _stores: object = data;
  static isTest: boolean = true;

    public static getStoreURLFromLink(link: AV.ILink): string {
        var retval: string;

        if (!link.storeId || link.storeId == undefined) {
            
            if (link.region == "USD") {
                link.storeId = "ST-USDW";
                retval = "https://usd-store.actavivo.com/";
            } else if (link.region == "UST") {
                link.storeId = "ST-USTW";
                retval = "https://ust-store.actavivo.com/";
            } else {
                link.storeId = "ST-USCW";
                retval = "https://usc-store.actavivo.com/";
            }
        } else {
            retval = MediaStore._stores[link.storeId];
        }

        if (!retval) {
            retval = "https://usc-store.actavivo.com/";
            MediaStore._stores[link.storeId] = retval;
            MediaStore.UpdateStores();
        }

        return retval;
    }
  public static getStoreURL(store?: string | null): string {
    var retval: string;

    if (!store || store == undefined) {
      //TODO: Remove when we reset env
      if (window.location.hostname == "dev.actavivo.com") {
        store = "ST-USDW";
        retval = "https://usd-store.actavivo.com/";
      } else if (window.location.hostname == "qa.actavivo.com") {
        store = "ST-USTW";
        retval = "https://ust-store.actavivo.com/";
      } else if (!this.isTest && window.location.hostname == "localhost") {
        store = "ST-USDW";
        retval = "https://usd-store.actavivo.com/";
      } else if (this.isTest && window.location.hostname == "localhost") {
        store = "ST-USTW";
        retval = "https://ust-store.actavivo.com/";
      } else {
        store = "ST-USCW";
        retval = "https://usc-store.actavivo.com/";
      }
    } else {
      retval = MediaStore._stores[store];
    }

    if (!retval) {
      retval = "https://usc-store.actavivo.com/";
      MediaStore._stores[store] = retval;
      MediaStore.UpdateStores();
    }

    return retval;
  }

  public static async init() {
    await MediaStore.UpdateStores();
    let s = await Store.GetObj<object>("MediaStore");
    if (s) MediaStore._stores = s;
  }

  public static async UpdateStores() {
    try {
      let s: any = await Server.get<object>("/api/Base/Stores");

      if (s) {
        MediaStore._stores = JSON.parse(s);
        await Store.Set("MediaStore", MediaStore._stores);
      }
    } catch {
      console.log("failed to get stores");
    }
  }
}
